var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79094 6.60329C8.77179 6.48015 9.73899 6.87488 10.3593 7.63899C10.4048 7.69508 10.4861 7.70735 10.5444 7.66474C10.8254 7.45942 11.0673 7.20292 11.257 6.90682C12.4391 5.06241 11.1264 2.57291 8.88367 2.57291C7.42019 2.57291 6.21395 3.69446 6.0797 5.12327C6.07428 5.18099 6.10616 5.2361 6.15919 5.25953C6.77141 5.53031 7.29444 5.97645 7.66186 6.54366C7.6897 6.58669 7.7401 6.60966 7.79094 6.60329Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88328 2.13958C9.12262 2.13958 9.31662 1.94556 9.31662 1.70625V0.839583C9.31662 0.600275 9.12262 0.40625 8.88328 0.40625C8.64395 0.40625 8.44995 0.600275 8.44995 0.839583V1.70625C8.44995 1.94556 8.64395 2.13958 8.88328 2.13958Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4333 4.95625H12.5666C12.3273 4.95625 12.1333 5.15028 12.1333 5.38959C12.1333 5.62889 12.3273 5.82292 12.5666 5.82292H13.4333C13.6726 5.82292 13.8666 5.62889 13.8666 5.38959C13.8666 5.15028 13.6726 4.95625 13.4333 4.95625Z",
    fill: "#787878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7939 7.68772C11.6248 7.5185 11.3504 7.5185 11.1811 7.68772C11.0119 7.85696 11.0119 8.13132 11.1811 8.30053L11.7939 8.91334C11.8785 8.99798 11.9894 9.04028 12.1003 9.04028C12.483 9.04028 12.6805 8.57426 12.4067 8.30056L11.7939 7.68772Z",
    fill: "#787878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97314 3.09147C6.14236 3.26072 6.41671 3.26072 6.58596 3.09147C6.7552 2.92223 6.7552 2.64787 6.58596 2.47866L5.97314 1.86584C5.80398 1.69663 5.5296 1.69663 5.36033 1.86584C5.19109 2.03509 5.19109 2.30944 5.36033 2.47866L5.97314 3.09147Z",
    fill: "#787878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.488 3.21843C11.5989 3.21843 11.7098 3.17612 11.7944 3.09149L12.4072 2.47867C12.5765 2.30942 12.5765 2.03507 12.4072 1.86585C12.238 1.69664 11.9636 1.69661 11.7944 1.86585L11.1816 2.4787C10.9078 2.75248 11.1054 3.21843 11.488 3.21843Z",
    fill: "#787878"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0894 9.83129C10.4234 8.18533 8.69968 6.91631 7.23789 7.66641C6.9166 6.60612 5.93185 5.83424 4.76667 5.83424C3.2545 5.83424 2.06066 7.12934 2.1951 8.64702C0.966821 8.74297 0 9.77003 0 11.023C0 12.3356 1.06343 13.4063 2.38333 13.4063H10.1292C11.1164 13.4063 11.9167 12.606 11.9167 11.6188C11.9167 10.6753 11.1742 9.83129 10.0894 9.83129Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/Weather.99e0aed04fe33146c5c29cd15a3c6851.svg";
export { ForwardRef as ReactComponent };